import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import { api } from '@bilibili-maoer/web-utils';
import qs from 'qs';
import { getFetch, postFetch } from '../../utils/fetcher.js';
import { DEFAULT_REGION } from '../utils/constants.js';
import '../../toast/index.js';
import '@babel/runtime-corejs3/helpers/toConsumableArray';
import '@babel/runtime-corejs3/helpers/classCallCheck';
import '@babel/runtime-corejs3/helpers/createClass';
import '@babel/runtime-corejs3/core-js/parse-int';
import '@babel/runtime-corejs3/core-js/promise';
import 'lodash-es';

var _excluded = ["login_name", "post_type", "region"];

var _SendCodeTypeSceneMap;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var SLIDE_CHECK_APP_KEY = 'FFFF0N0N0000000016A7';
var ESendCodeType;

(function (ESendCodeType) {
  /* eslint-disable no-magic-numbers */
  ESendCodeType[ESendCodeType["Regist"] = 0] = "Regist";
  ESendCodeType[ESendCodeType["Bind"] = 2] = "Bind";
  ESendCodeType[ESendCodeType["Login"] = 3] = "Login";
  ESendCodeType[ESendCodeType["Forgetpw"] = 9] = "Forgetpw";
  ESendCodeType[ESendCodeType["SMSLogin"] = 16] = "SMSLogin";
  /**
   * 申请提权
   */

  ESendCodeType[ESendCodeType["ImportantOperation"] = 18] = "ImportantOperation";
  /* eslint-enable no-magic-numbers */
})(ESendCodeType || (ESendCodeType = {})); // TODO: 等接口支持后更新


var SendCodeTypeSceneMap = (_SendCodeTypeSceneMap = {}, _defineProperty(_SendCodeTypeSceneMap, ESendCodeType.Regist, 'register'), _defineProperty(_SendCodeTypeSceneMap, ESendCodeType.Bind, ''), _defineProperty(_SendCodeTypeSceneMap, ESendCodeType.Login, 'login'), _defineProperty(_SendCodeTypeSceneMap, ESendCodeType.Forgetpw, ''), _defineProperty(_SendCodeTypeSceneMap, ESendCodeType.SMSLogin, 'login'), _defineProperty(_SendCodeTypeSceneMap, ESendCodeType.ImportantOperation, ''), _SendCodeTypeSceneMap);
var fetchCaptchaChallenge = function fetchCaptchaChallenge(type) {
  var _context;

  return getFetch({
    url: _concatInstanceProperty(_context = "".concat(api.MISSEVAN_API_PREFIX_URL, "/x/captcha/challenge")).call(_context, SendCodeTypeSceneMap[type] ? "?scene=".concat(SendCodeTypeSceneMap[type]) : '')
  });
};
var ESendCodeMessageType;

(function (ESendCodeMessageType) {
  /* eslint-disable no-magic-numbers */
  ESendCodeMessageType[ESendCodeMessageType["Failed"] = -1] = "Failed";
  ESendCodeMessageType[ESendCodeMessageType["ShowToast"] = 0] = "ShowToast";
  ESendCodeMessageType[ESendCodeMessageType["ShowUnderAccount"] = 1] = "ShowUnderAccount";
  ESendCodeMessageType[ESendCodeMessageType["ShowUnderPassword"] = 2] = "ShowUnderPassword";
  ESendCodeMessageType[ESendCodeMessageType["ShowBothAccountPassword"] = 3] = "ShowBothAccountPassword";
  ESendCodeMessageType[ESendCodeMessageType["ShowUnderCode"] = 5] = "ShowUnderCode";
  ESendCodeMessageType[ESendCodeMessageType["ShowCaptcha"] = 6] = "ShowCaptcha";
  /* eslint-enable no-magic-numbers */
})(ESendCodeMessageType || (ESendCodeMessageType = {}));

var sendCode = function sendCode(_ref) {
  var login_name = _ref.login_name,
      post_type = _ref.post_type,
      region = _ref.region,
      params = _objectWithoutProperties(_ref, _excluded);

  return postFetch({
    url: "".concat(api.MISSEVAN_API_PREFIX_URL, "/account/sendcode"),
    body: qs.stringify(_objectSpread({
      login_name: login_name,
      post_type: post_type,
      region: region || DEFAULT_REGION.code
    }, params))
  });
};

export { ESendCodeMessageType, ESendCodeType, SLIDE_CHECK_APP_KEY, SendCodeTypeSceneMap, fetchCaptchaChallenge, sendCode };
